import React from 'react';
import { Container, SectionHeader } from '../ui';
import { STEPS } from '../../data/marketing';

// 4-step "how it works" section.
const HowItWorks = () => (
  <section id="how" className="bg-ink-50 py-16 sm:py-24 scroll-mt-16">
    <Container>
      <SectionHeader
        align="center"
        eyebrow="How it works"
        title="Live in your district in days, not months"
        subtitle="No hardware to buy, no app for fans to install. Valley Tickets sets up around your district."
      />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-10">
        {STEPS.map((s, i) => (
          <div key={s.n} className="relative">
            <div className="text-5xl font-extrabold font-display text-brand-100 select-none">{s.n}</div>
            <h3 className="mt-2 text-lg font-bold font-display text-ink-900">{s.title}</h3>
            <p className="mt-2 text-ink-500 leading-relaxed">{s.desc}</p>
            {i < STEPS.length - 1 && (
              <div className="hidden sm:block absolute top-7 right-[-12px] text-brand-300 text-2xl">→</div>
            )}
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default HowItWorks;
